import type { ClientSearchSortOrder, SearchSortOrder, ServiceSearchSortOrder, } from "../store/schema/SearchTableQuery";

/**
 * Whether the sort order must be applied on the client after every result has been fetched.
 */
export function isClientSearchSortOrder(sortOrder: SearchSortOrder | undefined): sortOrder is ClientSearchSortOrder {
    return sortOrder === "Sender" || sortOrder === "SenderDescending";
}

/**
 * Whether the sort order sorts by sender, in either direction.
 */
export function isSenderSearchSortOrder(sortOrder: SearchSortOrder | undefined): sortOrder is "Sender" | "SenderDescending" {
    return sortOrder === "Sender" || sortOrder === "SenderDescending";
}

/**
 * Maps a search sort order onto the order the search service should fetch results in. Client-side
 * sort orders fetch newest first so the fetched set is stable and the date tiebreak is cheap.
 */
export function getServiceSearchSortOrder(sortOrder: SearchSortOrder | undefined): ServiceSearchSortOrder | undefined {
    return isClientSearchSortOrder(sortOrder) ? "DateTime" : sortOrder;
}
